import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import GalleryLanding from "../views/GalleryLanding";
import { Helmet } from "react-helmet-async";

export default function Gallery(props) {
  const appContext = useContext(AppContext);

  const [view, setView] = useState(null);

  async function init() {
    //run initializations here
  }

  function getView() {
    if (!appContext.navSubItem && !appContext.navExtraItem && !appContext.navMoreItem) {
      return <GalleryLanding />;
    }

    return null;
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    const _view = getView();
    if (_view) {
      setView(_view);
    }
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem]);

  return (
    <>
    <Helmet>
      <title>Photo Gallery | Zanzibar Mission Tours</title>
      <meta name="description" content="Browse our collection of stunning photos from Zanzibar tours, safaris, beaches, and cultural experiences." />
      <meta name="keywords" content="Zanzibar photos, safari gallery, travel images, Tanzania pictures" />
      <meta property="og:title" content="Photo Gallery | Zanzibar Mission Tours" />
      <meta property="og:description" content="Browse our collection of stunning photos from Zanzibar tours, safaris, and experiences." />
      <meta property="og:url" content="https://zanzibarmissiontour.com/#/gallery" />
    </Helmet>
    {view}
  </>
  );
}
